import { __read, __spreadArray } from "tslib";
import { useCallback, useState, startTransition } from 'react';
// eslint-disable-next-line arrow-parens
export var useTransitionState = function () {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    var _a = __read(useState.apply(void 0, __spreadArray([], __read(params), false)), 2), state = _a[0], setState = _a[1];
    var setTransitionSet = useCallback(function (val) {
        if (startTransition) {
            startTransition(function () {
                setState(val);
            });
        }
        else {
            setState(val);
        }
    }, []);
    return [state, setTransitionSet];
};
